module.exports = __webpack_public_path__ + "img/202101.9887f3de.png";